import { createFileRoute } from "@tanstack/react-router";
import { SeatingPage } from "@/features/seating/seating-page";

export const Route = createFileRoute("/app/w/$weddingId/seating")({ component: SeatingPage });
